import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Projects.css';

const Projects = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <section className="learn-page">
            <div className="learn-container">
                <div className="learn-intro" data-aos="fade-up">
                    <span className="learn-eyebrow">RESEARCH &amp; LEARNING</span>
                    <h1 className="learn-title">Learning Programmes</h1>
                    <p className="learn-subtitle">
                        Discover our comprehensive programs designed to bridge the gap between passion and the future of research in AI and Life Sciences.
                    </p>
                </div>

                <div className="learn-grid">
                    <div className="learn-card-col" data-aos="fade-up" data-aos-delay="100">
                        <Link to="/learn/multi-agent" className="learn-glass-card">
                            <div className="learn-card-media">
                                <img src="/images1.jpg.webp" alt="Multi-Agent Systems Poster" />
                            </div>
                            <div className="learn-card-content">
                                <h3 className="learn-card-title">Multi-Agent Systems &amp; Autonomous AI</h3>
                                <p className="learn-card-desc">
                                    Explore the rapidly emerging field of multi-agent systems and learn how intelligent agents can automate research processes and accelerate scientific discovery.
                                </p>
                                <div className="learn-card-footer">
                                    <span className="learn-btn-link">
                                        View Details
                                        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                                            <line x1="5" y1="12" x2="19" y2="12"></line>
                                            <polyline points="12 5 19 12 12 19"></polyline>
                                        </svg>
                                    </span>
                                </div>
                            </div>
                        </Link>
                    </div>

                    <div className="learn-card-col" data-aos="fade-up" data-aos-delay="200">
                        <Link to="/learn/bioinformatics" className="learn-glass-card">
                            <div className="learn-card-media">
                                <img src="/chembio1.png" alt="Bioinformatics Poster" />
                            </div>
                            <div className="learn-card-content">
                                <h3 className="learn-card-title">International Bioinformatics Bridge Programme</h3>
                                <p className="learn-card-desc">
                                    Bridge your passion for life sciences with the future of research. Take the next step into computational biology through guided learning and global collaboration.
                                </p>
                                <div className="learn-card-footer">
                                    <span className="learn-btn-link">
                                        View Details
                                        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                                            <line x1="5" y1="12" x2="19" y2="12"></line>
                                            <polyline points="12 5 19 12 12 19"></polyline>
                                        </svg>
                                    </span>
                                </div>
                            </div>
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Projects;